module.exports = __webpack_public_path__ + "img/icon-info.86faa565.svg";